// FILECONTENT_START src/common/components/DataGrid/locales/hu.ts
import { GridLocaleText } from "@mui/x-data-grid-pro";
//@ts-ignore
const gridLocaleHu: GridLocaleText = {
  // Root
  noRowsLabel: "Nem található sor",
  noResultsOverlayLabel: "Nincs eredmény.",
  errorOverlayDefaultLabel: "Váratlan hiba történt.",

  // Density selector toolbar button text
  toolbarDensity: "Sűrűség",
  toolbarDensityLabel: "Sűrűség",
  toolbarDensityCompact: "Kompakt",
  toolbarDensityStandard: "Alapértelmezett",
  toolbarDensityComfortable: "Komfort",

  // Columns selector toolbar button text
  toolbarColumns: "Oszlopok",
  toolbarColumnsLabel: "Oszlop választó",

  // Filters toolbar button text
  toolbarFilters: "Szűrők",
  toolbarFiltersLabel: "Szűrők megjelenítése",
  toolbarFiltersTooltipHide: "Szűrők Elrejtése",
  toolbarFiltersTooltipShow: "Szűrők Mutatása",
  toolbarFiltersTooltipActive: (count: number) =>
    count !== 1 ? `${count} aktív Szűrők` : `${count} aktív Szűrő`,

  // Export selector toolbar button text
  toolbarExport: "Exportálás",
  toolbarExportLabel: "Exportálás",
  toolbarExportCSV: "CSV letöltés",
  toolbarExportPrint: "Nyomtatás",

  // Columns panel text
  columnsPanelTextFieldLabel: "Oszlop keresése",
  columnsPanelTextFieldPlaceholder: "Oszlopcím",
  columnsPanelDragIconLabel: "Oszlop rendezése",
  columnsPanelShowAllButton: "Összes mutatása",
  columnsPanelHideAllButton: "Összes elrejtése",

  // Filter panel text
  filterPanelAddFilter: "Szűrő hozzáadása",
  filterPanelDeleteIconLabel: "Löschen",
  filterPanelOperators: "Operátorok",
  filterPanelOperatorAnd: "És",
  filterPanelOperatorOr: "Vagy",
  filterPanelColumns: "Oszlopok",
  filterPanelInputLabel: "Érték",
  filterPanelInputPlaceholder: "Szűrési érték",

  //Filter value
  filterValueAny: "Mindegyik",
  filterValueTrue: "Igaz",
  filterValueFalse: "Hamis",

  // Filter operators text
  filterOperatorContains: "tartalmaz",
  filterOperatorEquals: "egyenlő",
  filterOperatorStartsWith: "kezdődik",
  filterOperatorEndsWith: "végződik",
  filterOperatorIs: "létezik",
  filterOperatorNot: "nem létezik",
  filterOperatorOnOrAfter: "ist an oder nach",
  filterOperatorBefore: "ist vor",
  filterOperatorOnOrBefore: "ist an oder vor",
  filterOperatorAfter: "ist nach",
  filterOperatorIsEmpty: "üres",
  filterOperatorIsNotEmpty: "nem üres",

  //Missing
  checkboxSelectionHeaderName: "Kiválasztás",
  booleanCellTrueLabel: "Igaz",
  booleanCellFalseLabel: "Hamis",
  actionsCellMore: "Több",

  // Column menu text
  columnMenuLabel: "Menü",
  columnMenuShowColumns: "Oszlopok mutatása",
  columnMenuFilter: "Szűrő",
  columnMenuHideColumn: "Elrejtés",
  columnMenuUnsort: "sorrendezés kikapcsolása",
  columnMenuSortAsc: "Sorrendezés növekvő",
  columnMenuSortDesc: "Sorrendezés csökkenő",

  pinToLeft: "Pin to Left",
  pinToRight: "Pin to right",
  unpin: "Unpin",
  treeDataGroupingHeaderName: "treeDataGroupingHeaderName",
  treeDataExpand: "treeDataExpand",
  treeDataCollapse: "treeDataCollapse",
  // Column header text
  columnHeaderFiltersTooltipActive: (count: number) =>
    count !== 1 ? `${count} aktív Szűrő` : `${count} aktív Szűrő`,
  columnHeaderFiltersLabel: "Szűrők Mutatása",
  columnHeaderSortIconLabel: "Sorrendezés",

  // Rows selected footer text
  footerRowSelected: (count: number) =>
    count !== 1
      ? `${count.toLocaleString()} Sor kiválasztva`
      : `${count.toLocaleString()} Sor kiválasztva`,

  // Total rows footer text
  footerTotalRows: "Összesen:",

  // Total visible rows footer text
  footerTotalVisibleRows: (visibleCount: number, totalCount: number) =>
    `${visibleCount.toLocaleString()} / ${totalCount.toLocaleString()}`,

  // Actions cell more text
  // actionsCellMore: 'more',
  MuiTablePagination: {
    labelRowsPerPage: "Sorok oldalanként",
    labelDisplayedRows: ({ from, to, count }) => {
      return `${from}-${to} / ${count !== -1 ? count : `több mint ${to}`}`;
    },
  },
};

export default gridLocaleHu;

// FILECONTENT_END src/common/components/DataGrid/locales/hu.ts